import ArrowLeftOutlined from '@ant-design/icons/ArrowLeftOutlined';
import DashboardOutlined from '@ant-design/icons/DashboardOutlined';
import WalletOutlined from '@ant-design/icons/WalletOutlined';
import ArrowUpOutlined from '@ant-design/icons/ArrowUpOutlined';
import ArrowDownOutlined from '@ant-design/icons/ArrowDownOutlined';
import ApartmentOutlined from '@ant-design/icons/ApartmentOutlined';
import BankOutlined from '@ant-design/icons/BankOutlined';
import CreditCardOutlined from '@ant-design/icons/CreditCardOutlined';
import LineChartOutlined from '@ant-design/icons/LineChartOutlined';
import BarChartOutlined from '@ant-design/icons/BarChartOutlined';
import CloudUploadOutlined from '@ant-design/icons/CloudUploadOutlined';
import ApiOutlined from '@ant-design/icons/ApiOutlined';
import FileDoneOutlined from '@ant-design/icons/FileDoneOutlined';
import FileTextOutlined from '@ant-design/icons/FileTextOutlined';
import ProfileOutlined from '@ant-design/icons/ProfileOutlined';
import SwapOutlined from '@ant-design/icons/SwapOutlined';
import LockOutlined from '@ant-design/icons/LockOutlined';
import FolderOpenOutlined from '@ant-design/icons/FolderOpenOutlined';
import ToolOutlined from '@ant-design/icons/ToolOutlined';
import UnorderedListOutlined from '@ant-design/icons/UnorderedListOutlined';
import SendOutlined from '@ant-design/icons/SendOutlined';
import TableOutlined from '@ant-design/icons/TableOutlined';

const financeiro = {
  id: 'group-financeiro',
  title: 'Financeiro',
  type: 'group',
  children: [
    {
      id: 'back-to-core',
      title: 'Voltar ao Principal',
      type: 'item',
      url: '/dashboard',
      icon: ArrowLeftOutlined,
      breadcrumbs: false
    },
    {
      id: 'dashboard-financeiro',
      title: 'Dashboard',
      type: 'item',
      url: '/financeiro/dashboard',
      icon: DashboardOutlined,
      breadcrumbs: false
    },
    {
      id: 'financeiro-movimentacoes',
      title: 'Movimentações',
      type: 'collapse',
      icon: WalletOutlined,
      children: [
        {
          id: 'lancamentos',
          title: 'Lançamentos',
          type: 'item',
          url: '/financeiro/lancamentos',
          icon: UnorderedListOutlined,
          permissions: ['financeiro.lancamentos.view'],
          breadcrumbs: false
        },
        {
          id: 'contas-pagar',
          title: 'Contas a Pagar',
          type: 'item',
          url: '/financeiro/contas-pagar',
          icon: ArrowUpOutlined,
          permissions: ['financeiro.lancamentos.view'],
          breadcrumbs: false
        },
        {
          id: 'contas-receber',
          title: 'Contas a Receber',
          type: 'item',
          url: '/financeiro/contas-receber',
          icon: ArrowDownOutlined,
          permissions: ['financeiro.lancamentos.view'],
          breadcrumbs: false
        },
        {
          id: 'pagamentos-pix',
          title: 'Pagamentos',
          type: 'item',
          url: '/financeiro/pagamentos',
          icon: SendOutlined,
          permissions: ['financeiro.pagamentos.view'],
          breadcrumbs: false
        },
        {
          id: 'faturamento',
          title: 'Faturamento do mês',
          type: 'item',
          url: '/financeiro/faturamento',
          icon: FileDoneOutlined,
          permissions: ['financeiro.faturamento.view'],
          breadcrumbs: false
        },
        {
          id: 'faturamento-perfis',
          title: 'Perfis de faturamento',
          type: 'item',
          url: '/financeiro/faturamento/perfis',
          icon: ProfileOutlined,
          permissions: ['financeiro.faturamento.configurar'],
          breadcrumbs: false
        },
        {
          id: 'faturamento-atividades-fiscais',
          title: 'Atividades fiscais',
          type: 'item',
          url: '/financeiro/faturamento/atividades-fiscais',
          icon: ProfileOutlined,
          permissions: ['financeiro.faturamento.configurar'],
          breadcrumbs: false
        },
        {
          id: 'integracao-asaas',
          title: 'Integração Asaas',
          type: 'item',
          url: '/financeiro/integracoes/asaas',
          icon: ApiOutlined,
          permissions: ['financeiro.faturamento.configurar'],
          breadcrumbs: false
        },
        {
          id: 'faturas',
          title: 'Faturas',
          type: 'item',
          url: '/financeiro/faturas',
          icon: FileTextOutlined,
          permissions: ['financeiro.lancamentos.view'],
          breadcrumbs: false
        },
        {
          id: 'conciliacao',
          title: 'Conciliação',
          type: 'item',
          url: '/financeiro/conciliacao',
          icon: SwapOutlined,
          breadcrumbs: false
        }
      ]
    },
    {
      id: 'financeiro-cadastros',
      title: 'Cadastros',
      type: 'collapse',
      icon: FolderOpenOutlined,
      children: [
        {
          id: 'categorias',
          title: 'Categorias',
          type: 'item',
          url: '/financeiro/categorias',
          icon: ApartmentOutlined,
          permissions: ['financeiro.categorias.view'],
          breadcrumbs: false
        },
        {
          id: 'centros-custo',
          title: 'Centros de Custo',
          type: 'item',
          url: '/financeiro/centros-custo',
          icon: BankOutlined,
          permissions: ['financeiro.centros-custo.view'],
          breadcrumbs: false
        },
        {
          id: 'contas-bancarias',
          title: 'Contas Bancárias',
          type: 'item',
          url: '/financeiro/contas-bancarias',
          icon: CreditCardOutlined,
          breadcrumbs: false
        },
        {
          id: 'investimentos',
          title: 'Investimentos',
          type: 'item',
          url: '/financeiro/investimentos',
          icon: LineChartOutlined,
          breadcrumbs: false
        },
        {
          id: 'bancos',
          title: 'Bancos',
          type: 'item',
          url: '/financeiro/bancos',
          icon: BankOutlined,
          breadcrumbs: false
        }
      ]
    },
    {
      id: 'relatorios',
      title: 'Relatórios',
      type: 'item',
      url: '/financeiro/relatorios',
      icon: BarChartOutlined,
      permissions: ['financeiro.relatorios.view'],
      breadcrumbs: false
    },
    {
      // O plano do ano por categoria × mês. Fica logo abaixo de Relatórios porque é o que dá
      // sentido ao "Orçado × Realizado" de lá: sem orçamento lançado, aquele relatório só tem
      // uma coluna. A permissão é a de categorias — o orçamento é lançado na dimensão do plano
      // de contas, e quem o edita precisa de `financeiro.categorias.manage`.
      id: 'orcamento',
      title: 'Orçamento',
      type: 'item',
      url: '/financeiro/orcamento',
      icon: TableOutlined,
      permissions: ['financeiro.categorias.view'],
      breadcrumbs: false
    },
    {
      id: 'financeiro-operacoes',
      title: 'Operações',
      type: 'collapse',
      icon: ToolOutlined,
      children: [
        {
          id: 'importacao',
          title: 'Importação',
          type: 'item',
          url: '/financeiro/importacao',
          icon: CloudUploadOutlined,
          permissions: ['financeiro.lancamentos.create'],
          breadcrumbs: false
        },
        {
          id: 'fechamentos',
          title: 'Fechamentos',
          type: 'item',
          url: '/financeiro/fechamentos',
          icon: LockOutlined,
          breadcrumbs: false
        }
      ]
    }
  ]
};

export default financeiro;
